// extracted by mini-css-extract-plugin
export default {"Wrapper":"ThreadWithDraftCompose_Wrapper__i5QXu","LoadingThreadDetails":"ThreadWithDraftCompose_LoadingThreadDetails__flUDj"};